import { memo } from "react";

function Icon_MidstreamAllFacilities() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="16"
        y="9"
        width="6"
        height="6"
        rx="0.5"
        transform="rotate(90 16 9)"
        fill="currentColor"
      />
      <rect
        x="16"
        y="1"
        width="6"
        height="6"
        rx="0.5"
        transform="rotate(90 16 1)"
        fill="currentColor"
      />
      <ellipse
        cx="3"
        cy="3"
        rx="3"
        ry="3"
        transform="rotate(90 3 3)"
        fill="currentColor"
      />
      <ellipse
        cx="3"
        cy="13"
        rx="3"
        ry="3"
        transform="rotate(90 3 13)"
        fill="currentColor"
      />
      <path d="M8 4L10 4" stroke="currentColor" />
      <path d="M8 12L10 12" stroke="currentColor" />
      <path d="M3 3H7.5V13H3" stroke="currentColor" strokeLinejoin="round" />
    </svg>
  );
}

export default memo(Icon_MidstreamAllFacilities);
